import { takeLatest } from 'redux-saga/effects';
import {
  getAccountListSuccess, getAccountListFail,
  getAccountDetailsSuccess, getAccountDetailsFail
} from './accountState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/admin/accounts');
const redirectData = {route:'/console/accounts', mode: 'list', recordId:0 };
const modelName = 'Accounts';
const modelId = 'id';

function* getAccountList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getAccountListSuccess, 
		getAccountListFail);
}

function* getAccountDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getAccountDetailsSuccess, 
		getAccountDetailsFail);		
}

function* doAccountCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getAccountDetailsSuccess, 
		getAccountDetailsFail,
		`${modelName} record has been created.`,
		redirectData);
}

function* doAccountUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getAccountDetailsSuccess, 
		getAccountDetailsFail,
		`${modelName} record has been updated.`,
		redirectData);	
}

function* doAccountDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getAccountDetailsSuccess, 
		getAccountDetailsFail,
		`${modelName} record has been deleted.`,
		{...redirectData, mode: data.payload.mode});	
}

function* accountSaga() {
  yield takeLatest('account/getAccountList', getAccountList);
  yield takeLatest('account/getAccountDetails', getAccountDetails);
  yield takeLatest('account/doAccountCreate', doAccountCreate);
  yield takeLatest('account/doAccountUpdate', doAccountUpdate);
  yield takeLatest('account/doAccountDelete', doAccountDelete);  
}

export default accountSaga;
